import React from 'react'
import Language from '../Language';
import styles from './Header.module.css'
import { auth } from './../../store/auth';
import { observer } from 'mobx-react-lite';
import { AuthService } from '../../Service/auth';
import { notify } from '../../Utils/notify';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default observer(function Header() {
    const iconClass = auth.menuShow ? "fas fa-times" : "fas fa-bars"
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <div className={styles.HeaderWrapper}>
            <header>
                <div>
                    <div className={styles.MenuIconWrapper} onClick={() => {
                        auth.setMenuShow( !auth.menuShow )
                    }}>
                        <i
                            className={iconClass}
                        ></i>
                    </div>
                    <div onClick={() => {
                        navigate("/bt/students")
                    }}>
                        <div className={styles.logo}>
                            <img src="/img/AVN_new_SVG.svg" alt="" className={styles.logo_img} />
                        </div>
                    </div>
                </div>
                <Language />
                <h2>{
                    t("head.appTitle")}
                </h2>
                {
                    1 == 1 ? <div className={styles.Header_fio_container}>
                        <h3 onClick={() => {
                        }}>{auth.user.data? auth.user.data.name : ""} </h3>
                        <p  onClick={() => {
                            AuthService.logout().then(({ error,message }) => {
                                if (error) {
                                    notify(message, "error");
                                } else {
                                    notify(message, "success");
                                    auth.newUser({ isAuthenticated: false, data: {
                                        AVN20: 0,
                                        AVN_BT_report: 0,
                                        doljnost: 0,
                                        id: 0,
                                        name: ""
                                        }, isLoading: false });
                                    navigate(`/bt/login`);
                                }
                              })
                        }} >{t("st:other.exit")}</p>
                    </div> : null
                }
            </header>
        </div>
    )
})
